import { Icon, Link, Callout } from '@dev-spendesk/grapes';

import { unwrapQuery } from 'src/core/api/unwrapQuery';
import { useFeature } from 'src/core/common/hooks/useFeature';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';
import { useSpanishDprSettings } from 'src/core/modules/bookkeep/apis/useSpanishDprSettings';

import { SpanishDprArchiving } from './SpanishDprArchiving';
import { SpanishDprSwitch } from './SpanishDprSwitch';

export function SpanishDprSection() {
  const { t } = useTranslation('global');
  const isSpanishDprEnabled = useFeature(FEATURES.SPANISH_DPR);

  const spanishDprSettingsQuery = useSpanishDprSettings();
  const spanishDprSettings = unwrapQuery(spanishDprSettingsQuery);

  return (
    <>
      <SpanishDprSwitch isSpanishDprEnabled={isSpanishDprEnabled} />
      {isSpanishDprEnabled ? (
        <>
          <div className="separator my-24" />

          <div>
            <div className="gap-8">
              <div className="heading-l text-content-primary">
                {t('bookkeep.settings.spanishDpr.yearEndArchiving')}
              </div>
              <span className="body-m text-content-secondary-bg-secondary">
                {t('bookkeep.settings.spanishDpr.yearEndArchivingDescription')}{' '}
                <Link
                  href="https://helpcenter.spendesk.com/articles/9540095-how-to-digitise-your-paper-receipts-in-spain"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('bookkeep.settings.spanishDpr.helpCenter')}
                  <Icon name="arrow-top-right-square" />
                </Link>
              </span>
            </div>

            <SpanishDprArchiving currentSettings={spanishDprSettings} />
          </div>
        </>
      ) : (
        <Callout
          title={t('bookkeep.settings.spanishDpr.featureDisabled')}
          variant="alert"
          className="my-16"
        />
      )}
    </>
  );
}
